import { A, useLocation } from '@solidjs/router'
import { userStore } from '../../store'
import { bottomTabs } from './navData'
import { hasActivePremium } from '/common/subscription-access'
import { TokenCoin } from './TokenCoin'

export function BottomTabBar() {
  const location = useLocation()
  const loggedIn = () => userStore().loggedIn
  const isPlatformPremium = () => hasActivePremium(userStore().aifansSubscriptions)

  const isActive = (route: string) => {
    if (route === '/') return location.pathname === '/'
    return location.pathname.startsWith(route)
  }

  return (
    <nav
      class="cf-tabbar"
      style={{ 'backdrop-filter': 'blur(22px)', '-webkit-backdrop-filter': 'blur(22px)' }}
    >
      {bottomTabs.map((tab) => {
        // Premium tab: when the user has an active platform premium membership,
        // replace with a Tokens button that opens the buy-tokens popup instead.
        if (tab.id === 'premium' && isPlatformPremium()) {
          return (
            <button class="cf-tab" onClick={() => userStore.buyTokensModal(true)}>
              <TokenCoin size={22} />
              <span class="cf-tab-lbl">Tokens</span>
            </button>
          )
        }

        // Premium tab (non-premium state): render the SAME 💎 emoji the header
        // Premium button uses (TopBar `.cf-btn-premium`), not the blue DiamondIcon SVG.
        if (tab.id === 'premium') {
          return (
            <A href={tab.route} class={`cf-tab ${isActive(tab.route) ? 'active' : ''}`}>
              <span
                aria-hidden="true"
                style={{
                  // #207: occupy the same 24px box as the other tabs' SVG icons and
                  // center the glyph, so the "Premium" label aligns with the rest.
                  width: '24px',
                  height: '24px',
                  display: 'grid',
                  'place-items': 'center',
                  'font-size': '20px',
                  'line-height': '1',
                }}
              >
                💎
              </span>
              <span class="cf-tab-lbl">{tab.label}</span>
            </A>
          )
        }

        if ((tab as any).loggedInOnly && !loggedIn()) {
          return (
            <button
              class={`cf-tab ${isActive(tab.route) ? 'active' : ''}`}
              onClick={() => userStore.loginModal(true)}
            >
              <tab.icon size={22} />
              <span class="cf-tab-lbl">{tab.label}</span>
            </button>
          )
        }

        if (tab.fab) {
          return (
            <A href={tab.route} class={`cf-tab cf-fab ${isActive(tab.route) ? 'active' : ''}`}>
              <tab.icon size={24} />
            </A>
          )
        }

        return (
          <A href={tab.route} class={`cf-tab ${isActive(tab.route) ? 'active' : ''}`}>
            <tab.icon size={22} />
            <span class="cf-tab-lbl">{tab.label}</span>
          </A>
        )
      })}
    </nav>
  )
}
